export default "__VITE_ASSET__C3q_ZbOX__"